export var ActionCreatorType;
(function (ActionCreatorType) {
    ActionCreatorType["TYPE_ONLY"] = "TYPE_ONLY";
    ActionCreatorType["PROPS"] = "PROPS";
    ActionCreatorType["PAYLOAD"] = "PAYLOAD";
})(ActionCreatorType || (ActionCreatorType = {}));
export var ActionOptType;
(function (ActionOptType) {
    ActionOptType["PROPS"] = "PROPS";
    ActionOptType["PAYLOAD"] = "PAYLOAD";
})(ActionOptType || (ActionOptType = {}));
function extend(obj, p) {
    const result = obj;
    for (const key of Object.keys(p)) {
        result[key] = p[key];
    }
    return result;
}
export function action(type, pType) {
    if (pType) {
        switch (pType.__tsdux_opt__) {
            case ActionOptType.PROPS: {
                //tslint:disable-next-line: no-shadowed-variable
                const create = (props) => extend(extend({}, props), { type });
                const properties = {
                    __tsdux_action__: ActionCreatorType.PROPS,
                    type: type,
                    //tslint:disable-next-line: no-shadowed-variable
                    create(props) {
                        return create(props);
                    },
                    action: undefined,
                };
                //tslint:disable-next-line: no-shadowed-variable
                const creator = extend(create, properties);
                return creator;
            }
            case ActionOptType.PAYLOAD: {
                //tslint:disable-next-line: no-shadowed-variable
                const create = (payload) => ({ type, payload });
                const properties = {
                    __tsdux_action__: ActionCreatorType.PAYLOAD,
                    type: type,
                    //tslint:disable-next-line: no-shadowed-variable
                    create(payload) {
                        return create(payload);
                    },
                    action: undefined,
                };
                const creator = extend(create, properties);
                return creator;
            }
            default:
                const x = pType;
                const jsonIndent = 2;
                const rep = JSON.stringify(x, undefined, jsonIndent);
                throw new Error(`tsdux error: use \`props\` or \`payload\` function when make an action creator\n    ${rep} is not created by \`props\` nor \`payload\``);
        }
    }
    else {
        const create = () => {
            return { type };
        };
        const properties = {
            __tsdux_action__: ActionCreatorType.TYPE_ONLY,
            type: type,
            create() {
                return create();
            },
            action: undefined,
        };
        const creator = extend(create, properties);
        return creator;
    }
}
export function props() {
    return { __tsdux_opt__: ActionOptType.PROPS };
}
export function payload() {
    return { __tsdux_opt__: ActionOptType.PAYLOAD };
}
//# sourceMappingURL=action.js.map